import { isTruckOwnershipType, TRUCK_OWNERSHIP_LABELS, TruckOwnershipType } from '@numeo/types-core'
import { Select } from 'components/ds2'

const NOT_SET = ''

const OWNERSHIP_OPTIONS = [
    { value: NOT_SET, label: 'Not set' },
    ...Object.values(TruckOwnershipType).map((value) => ({ value, label: TRUCK_OWNERSHIP_LABELS[value] })),
]

interface OwnershipTypeSelectProps {
    value?: TruckOwnershipType | null
    /** `null` clears the type — every truck write path turns it into an `$unset`. */
    onChange: (value: TruckOwnershipType | null) => void
}

/** Who holds the vehicle — Company, Owner Operator, Leased or Rental. Optional: "Not set" clears it. */
export const OwnershipTypeSelect: React.FC<OwnershipTypeSelectProps> = ({ value, onChange }) => (
    <Select
        variant="secondary"
        label="Ownership Type"
        data-testid="truck-ownership-select"
        placeholder="Select ownership type"
        value={value ?? NOT_SET}
        options={OWNERSHIP_OPTIONS}
        onChange={(next) => {
            if (next === NOT_SET) onChange(null)
            else if (isTruckOwnershipType(next)) onChange(next)
        }}
    />
)
